<template>
  <div>
    <app-header title="Film Types">
      <button
        v-router-link="{ name: 'filmtype-editor' }"
        class="btn btn-primary"
      >
        <i class="fa fa-plus-circle" /> New Film Type
      </button>
      <button
        v-router-link="{ name: 'filmtypecategory-list' }"
        class="btn btn-secondary ml-2"
      >
        Manage Categories
      </button>
      <button class="btn btn-secondary ml-2" @click="exportCSV()">
        Export CSV
      </button>
    </app-header>
    <loading-spinner v-if="!filmtypes" />
    <b-container v-else>
      <b-row>
        <b-col>
          <b-form-group label="Category">
            <b-form-select
              v-model="selectedCategory"
              v-if="filmtypecategories"
              :options="filmtypecategories"
              text-field="name"
              value-field="id"
            />
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group label="Filter">
            <search-input v-model="query" />
          </b-form-group>
          <!-- {{ total }} Film Types -->
        </b-col>
      </b-row>
      <b-table :items="displayFilmtypes" :fields="fields">
        <template v-slot:cell(name)="data">
          <span
            class="filmtypelist--clickable"
            @click="viewFilmtype(data.item)"
          >
            {{ data.item.name }}
          </span>
        </template>
        <template v-slot:cell(tablet_medium)="data">
          <span>
            {{ data.item.tablet_medium ? 'Yes' : 'No' }}
          </span>
        </template>
      </b-table>
    </b-container>
  </div>
</template>

<script>
import $api from '@/services/api';
import $csv from '@/services/csv';
import $search from '@/services/search';
import AppHeader from '@/components/AppHeader';
import SearchInput from '@/components/SearchInput';
import LoadingSpinner from '@/components/LoadingSpinner';

export default {
  components: {
    AppHeader,
    SearchInput,
    LoadingSpinner,
  },

  data: () => ({
    query: '',
    filmtypes: null,
    filmtypecategories: null,
    selectedCategory: 1,
    fields: [
      {
        key: 'id',
        label: 'ID',
      },
      'name',
      'description',
      'cycles',
      'pressure',
      'speed',
      'teneth_pressure',
      'teneth_speed',
      'teneth_mini_pressure',
      'teneth_mini_speed',
      'mycut_pressure',
      'mycut_speed',
      'hidden',
      {
        key: 'tablet_medium',
        label: 'Medium Tablet Cut Position',
      },
    ],
  }),

  computed: {
    displayFilmtypes() {
      return $search(this.filmtypes, this.query).filter((filmtype) => {
        if (!this.selectedCategory) return !filmtype.categories.length;
        return filmtype.categories.includes(this.selectedCategory);
      });
    },

    total() {
      return this.query ? this.displayFilmtypes.length : this.filmtypes.length;
    },
  },

  created() {
    this.refreshData();
  },

  methods: {
    async refreshData() {
      this.filmtypes = await $api.get('/v1/internal/filmtypes');
      this.filmtypecategories = await $api.get('/v1/common/filmtypecategories');
      this.filmtypecategories.push({ id: null, name: '[No Category]' });
    },

    exportCSV() {
      $csv.export(this.filmtypes, this.fields, `filmtypes.csv`);
    },

    viewFilmtype(item) {
      this.$router.push({ name: 'filmtype-detail', params: item });
    },
  },
};
</script>
<style scoped>
.filmtypelist--clickable:hover {
  cursor: pointer;
  text-decoration: underline;
}
</style>
